import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { isNative } from './native/tenant';

// Native MDT app: the WebView opens at "/", but this build is field-only, so
// enter on the MDT route before the router mounts (a token means resume the
// dashboard). Done here rather than via an in-render redirect so BrowserRouter
// initializes directly on the MDT path.
if (isNative()) {
  const p = window.location.pathname;
  if (!p.startsWith('/mdt') && !p.startsWith('/mobile/')) {
    const target = localStorage.getItem('token') ? '/mobile/mdt' : '/mdt';
    window.history.replaceState(null, '', target);
  }
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
